import { OyDomainType } from '@oy/types';
import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { reportComponentError } from 'src/utilities/sentry';

type ErrorBoundaryProps = {
  componentName: string;
  domain: OyDomainType;
  children: React.ReactNode;
};

const ErrorBoundary = ({
  componentName,
  domain,
  children,
}: ErrorBoundaryProps) => {
  const onError = (error: Error) => {
    // solution from https://github.com/remix-run/react-router/discussions/10333
    if (error.message.includes('dynamically imported module')) {
      window.location.reload();
    } else {
      reportComponentError({ name: componentName, domain, exception: error });
    }
  };

  return (
    <ReactErrorBoundary fallback={<></>} onError={onError}>
      <>{children}</>
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
